import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { CustomerTradeGroup } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerTradeGroupService extends TmsWebBaseEditService<CustomerTradeGroup, CustomerTradeGroup> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('CustomerTradeGroup', $localize`Customer Trade Group`, httpService, notificationService);
  }
}
